import { render, staticRenderFns } from "./PopupContent.vue?vue&type=template&id=057b0c7c&scoped=true"
import script from "./PopupContent.vue?vue&type=script&lang=js"
export * from "./PopupContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b0c7c",
  null
  
)

export default component.exports